import { Component,ViewChild, OnInit,Output, Input,HostListener,EventEmitter,ElementRef } from '@angular/core';
import { ListService } from '../../../services/list.service';
import { Repository } from '../../../services/repository'
import { NgSelectComponent } from '@ng-select/ng-select';
import {  DaoTaos_HocVien } from '../../../routes/menu'

import { BsModalComponent, BsModalBodyComponent, BsModalService } from 'ng2-bs3-modal';
import 'jquery'
import 'bootstrap'

//import { Lists_cmmt } from '../../../routes/menu'


const swal = require('sweetalert');
@Component({
  selector: 'app-daotao-cauhinhhienthiedit',
  templateUrl: './cauhinhhienthiedit.component.html',
    //templateUrl: 'ClientApp/routes/DanhMuc/data/data.component.html',
  styleUrls: ['./cauhinhhienthiedit.component.scss'],
    providers: [ListService, Repository]
})


export class cauhinhhienthieditComponent implements OnInit {

  @ViewChild('modaltuychinhmaubc') modaltuychinhmaubc: BsModalComponent;
  @ViewChild('dtsuamaubaocao') dtsuamaubaocao: any;

  doanhnghiepid: string = null;
  public ngaysinh: Date = null;
  public ngaycmnd: Date = null;
  quyen_them: boolean = false;
  quyen_sua: boolean = false;
  quyen_xoa: boolean = false;
  dsnganhangs: any;
  inputhangbaohiems: any;
  inputphongbans: any;
  inputhangxes: any;
  inputkhachhangs: any;
  inputmausacs: any;
  inputmodels: any;
  inputnhomctmts: any;
  indLoading: boolean = false;
  doituongSelect: any = {
    DonViId: null, UserName: null, ChiTiets: []
  };       
    nhomdtid:string=null;
  hoatdong: string = null;
  inputnhacungcaps: any = [
    { Ten_Doi_Tuong: "Cá nhân", Ma_Doi_Tuong: '0', Id: false },
    { Ten_Doi_Tuong: "Tổ chức", Ma_Doi_Tuong: '1', Id: true },
  ];

  dstrangthais: any = [
    { Ten: 'Nghỉ học', Id: 0 },
    { Ten: 'Học bình thường', Id: 1 },
    { Ten: 'Bảo lưu', Id: 2 }
    
  ];

  inputthus: any = [
    { Ten: 'Thứ 2', Id: 2 },
    { Ten: 'Thứ 3', Id: 3 },
    { Ten: 'Thứ 4', Id: 4 },
    { Ten: 'Thứ 5', Id: 5 },
    { Ten: 'Thứ 6', Id: 6 },
    { Ten: 'Thứ 7', Id: 7 },
    { Ten: 'Chủ nhật', Id: 8 }
  ];

  inputgioitinhs: any = [
    { Ten_Doi_Tuong: "Nữ", Ma_Doi_Tuong: '0', Id: false },
    { Ten_Doi_Tuong: "Nam", Ma_Doi_Tuong: '1', Id: true },
  ];

  inputloais: any = [
    { text: "Nhân công", value: 0 },
    { text: "Vật tư sơn", value: 1 },
  ];

  @ViewChild('slCapTren', { static: false }) slCapTren: NgSelectComponent;
  @Output() save: EventEmitter<any> = new EventEmitter();

  Password: string = null;
  PasswordNew: string = null;
  PasswordConfirm: string = null;
  username: string = null;
  public ngxCurrencyOptions = {
    prefix: '',
    thousands: '',
    decimal: '.',
    precision: 0,
    allowNegative: false
  };

    constructor( private _dataService: ListService, public repo: Repository) {
       
        
    }

    ngOnInit(): void {
       
    }

    // @HostListener('document:keydown', ['$event'])
    // public handleKeyboardEvent(event: KeyboardEvent): void {
      
    //   if(event.key==="F9")
    //   {
    //       this.saveproduct();
    //   }
    //   event.stopPropagation();
     
    // }

    comboSearchFn(term: string, item: any) {
        term = term.toLowerCase();
        return item.Ma_Doi_Tuong.toLowerCase().indexOf(term) > -1 || item.Ten_Doi_Tuong.toLowerCase().indexOf(term) > -1;
    }
  @ViewChild("mafocus", { static: false }) mafocus: ElementRef;
  bnguonkinhphi: boolean = false;
  bnhomctmt: boolean = false;
  currentUser: any;
  tieudectmt: any;
  tieudectmtplace: any;
  hosoid: string;
  TaiKhoan: string;
 
  loadDataInit(nhomdoituongid: string, id: string, donviid: string, rowdata: any) {

    this.doituongSelect = {
      DonViId: null, UserName: null, ChiTiets: []
    };

          this.doituongSelect.LopId = id;
          var authlogin = localStorage.getItem('currentUser');
          if (authlogin) {

            this.currentUser = JSON.parse(authlogin);
            this.username = this.currentUser.user_name;
            this.doituongSelect.UserName = this.currentUser.user_name;
            this.doituongSelect.DonViId = donviid;

            this.repo.postRequest("api/cauhinhhienthi/getbyds/", {
              DonViId: this.doituongSelect.DonViId
              , PhanHeId: DaoTaos_HocVien.id, UserName: this.username, ChiTiets: rowdata
            }
            )
              .subscribe(response => {
                this.doituongSelect.ChiTiets = response;
              });

           
           

            
            

          }    

       
    
       
   }
   
  public ngonngu(text: string) {
    return this.repo.NgonNgu(text);
  }
    public closeModal(){
        this.save.emit(null);
  }

  comboSearchFn2(term: string, item: any) {
    term = term.toLowerCase();
    return item.Ten.toLowerCase().indexOf(term) > -1;
  }
  comboSearchFn3(term: string, item: any) {
    term = term.toLowerCase();
    return item.SoTaiKhoan.toLowerCase().indexOf(term) > -1 || item.NganHang.toLowerCase().indexOf(term) > -1;
  }

  ThucHien() {
    
    //if (this.doituongSelect.NganHangId == null) {
    //  swal('Lỗi!', "Vui lòng chọn tài khoản.", 'error');
    //  return;
    //}

    //if (this.doituongSelect.Thang == null) {
    //  swal('Lỗi!', "Vui lòng chọn tháng.", 'error');
    //  return;
    //}
    //if (this.doituongSelect.Nam == null) {
    //  swal('Lỗi!', "Vui lòng chọn năm.", 'error');
    //  return;
    //}
    
    this.repo.postRequest("api/cauhinhhienthi/addorupdate/", this.doituongSelect
    )
      .subscribe(response => {
        if (response != null && response.match('OK')) {
          //swal('Saved!', 'Lưu thành công!.', 'success');
          this.save.emit(this.doituongSelect);
        }
        else if (response != null) {
          swal('Lỗi!', response, 'error');
        }

        console.log(response);

      });
  }

  
   
  mBackdrop: any;
  haveBackdrop() {
    if ($('.modal-backdrop').length > 0) {
      $('.modal-backdrop').css("z-index", -1)
      clearTimeout(this.mBackdrop);
      return true;
    }

    return false;
  }
  indexdt: number;
  cotdt: string;

  public tuychinhmaubaocao() {
    this.dtsuamaubaocao.loadDataInit("742B5605-196C-4F71-90D1-372561A1D83D");
    this.modaltuychinhmaubc.open();
  }
  
   


}
